import config from "@utils/config";
import { theme, type LBoxProps } from "@theme";
import LBox from "./LBox";
import { useTabBarHeight } from "@hooks/useTabBarHeight";
import { useActiveSongId } from "@utils/player";

type BottomBarPaddingType = LBoxProps & {
  defaultPadding?: number;
};

/**
 * This component is used to add padding to the bottom of pages when there is an active track playing. It's built into a lot of reusable list components, like LScrollView and LFlatList.
 */
const BottomBarPadding = (props: BottomBarPaddingType) => {
  const activeSongId = useActiveSongId();
  const tabBarHeight = useTabBarHeight();
  const padding = activeSongId
    ? tabBarHeight + config.UI.barMusicPlayerHeight + theme.spacing.m1
    : tabBarHeight + (props.defaultPadding || 0);

  return padding ? (
    <LBox
      borderTopLeftRadius="m"
      borderTopRightRadius="m"
      height={padding}
      width="100%"
      {...props}
    />
  ) : null;
};

export default BottomBarPadding;
